import { useFeature } from "../features";

/**
 * Returns true if any accessibility display mode axis is enabled.
 * Add new axis flags to the array as they ship.
 */
export const useIsAccessibilityModesEnabled = (): boolean => {
  const { featureEnabled } = useFeature();

  return [featureEnabled("accessibility_mode_contrast")].some(Boolean);
};
